import React from 'react';

const PerformanceOptimizer = () => {
  // No longer needed since all animations are removed
  return null;
};

export default PerformanceOptimizer;
